const paths = {
  metrics: { metrics: 'metrics' },
  sales: {
    sales: 'sales-workspace',
    onboardingPolicy: 'workflows/CUSTOMER_ONBOARDING/policy',
    featureCatalog: 'features',
    customers: 'customers',
  },
  profitability: { profitability: 'profitability' },
};

export const movementTypeOrder = [
  'NEW',
  'REACTIVATION',
  'EXPANSION',
  'CONTRACTION',
  'CHURN',
];

const movementTypeLabels = {
  NEW: 'New',
  REACTIVATION: 'Reactivation',
  EXPANSION: 'Expansion',
  CONTRACTION: 'Contraction',
  CHURN: 'Churn',
};

const movementMonth = row => String(row?.month || row?.effectiveDate || '').slice(0, 7);

export const groupCurrentPeriodMovements = (details = [], period, filter = 'ALL') => {
  const rows = Array.isArray(details) ? details.filter(row => (
    movementMonth(row) === period
    && movementTypeOrder.includes(row.type)
    && (filter === 'ALL' || row.type === filter)
  )) : [];

  return movementTypeOrder.map(type => {
    const typedRows = rows
      .filter(row => row.type === type)
      .sort((left, right) => String(right.effectiveDate || '').localeCompare(String(left.effectiveDate || '')));
    return {
      type,
      label: movementTypeLabels[type],
      rows: typedRows,
      total: typedRows.reduce((sum, row) => sum + Number(row.delta || 0), 0),
    };
  }).filter(group => group.rows.length > 0);
};

export const getCommercialIntelligenceDataPaths = section => paths[section] || {};
